import { memo } from 'react';
import IconButton from '@material-ui/core/IconButton';
import styled from 'styled-components';

const ChatIconButton = styled(IconButton)`
  padding: 6px;
`;

export default memo(ChatIconButton);
